import { render, staticRenderFns } from "./L10nWrapper.vue?vue&type=template&id=3cd5cdce&"
import script from "./L10nWrapper.vue?vue&type=script&lang=js&"
export * from "./L10nWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports